import './term.css';

import { CheckIcon, CloseIcon } from '@chakra-ui/icons';
import { Box, VStack } from '@chakra-ui/react';

export const TermConclusion = ({
  approved
}: {
  approved: boolean;
}): JSX.Element => {
  const message = approved
    ? 'Sessão encerrada, consentimento aprovado.'
    : 'Sessão encerrada, consentimento negado.';

  return (
    <>
      <Box
        w="100%"
        p={['30px 16px', '30px 16px', '30px 50px']}
        display="flex"
        flexDirection="column"
        alignItems="center"
      >
        <VStack
          // w="100%"
          m="15px !important"
          p="30px 45px 30px 45px"
          bg="#FFFFFF"
          boxShadow="0px 0px 9px 5px #0000000a"
          borderRadius="10px"
          alignItems={'left'}
        >
          <div
            style={{
              display: 'flex',
              background: approved ? 'green' : 'red',
              alignContent: 'center',
              alignItems: 'center',
              alignSelf: 'center',
              padding: '13px',
              borderRadius: '50%'
            }}
          >
            {approved ? (
              <CheckIcon boxSize={7} color="white" />
            ) : (
              <CloseIcon boxSize={7} color="white" />
            )}
          </div>
          <p
            style={{
              fontSize: '18px',
              padding: '15px 25px 10px 30px',
              fontWeight: 'bold',
              color: approved ? 'green' : 'red'
            }}
          >
            {message}
          </p>
        </VStack>
      </Box>
    </>
  );
};
